import { useStore } from 'vuex'

export function useFeatureUpsell() {
  const store = useStore()

  const getContent = (featureKey) => {
    const content = store.getters['feature-upsell/getContent'](featureKey)
    if (content && content.is_active !== false) {
      return content
    }
    return null
  }

  const isDismissed = (featureKey) => {
    try {
      return sessionStorage.getItem(`upsell_dismissed_${featureKey}`) === 'true'
    } catch {
      return false
    }
  }

  const dismiss = (featureKey) => {
    try {
      sessionStorage.setItem(`upsell_dismissed_${featureKey}`, 'true')
    } catch (e) {
      console.error('Failed to set sessionStorage dismiss for upsell:', e)
    }
  }

  const log = () => {
    // Lead signal
  }

  return {
    getContent,
    isDismissed,
    dismiss,
    log
  }
}
